'use client';

import Script from 'next/script';
import { JSX, useEffect, useState } from 'react';

import { fetchImpactUserData } from '../../actions/fetchUserDataAction';

// Impact requires us to SHA1 encode the email.
async function generateSha1(email: string) {
    // Encode the input string to a Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(email);
    // Generate the SHA-1 hash (an ArrayBuffer)
    const hashBuffer = await window.crypto.subtle.digest('SHA-1', data);
    // Convert the hash to a hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export function ImpactSetup(): JSX.Element {
    const [accountCode, setAccountCode] = useState('');
    const [email, setEmail] = useState('');
    const [customProfileId, setCustomProfileId] = useState('');

    useEffect(() => {
        void fetchImpactUserData().then(async (userData) => {
            const hashedEmail = await generateSha1(userData.userEmail);
            // Apply user data to Impact scripts
            if (userData) {
                setAccountCode(userData.accountCode);
                setEmail(hashedEmail);
                setCustomProfileId(userData.userVID);
            }
        });
    }, []);

    return (
        <Script id="impact_recurly_integration" type="text/javascript" strategy="beforeInteractive">
            {`
                (function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A6868756-6250-4e04-b2ba-cb32311980f21.js','script','ire',document,window);
                ire('identify', {
                    customerId: '${accountCode}', 
                    customerEmail: '${email}', 
                    customProfileId: '${customProfileId}'
                });
            `}
        </Script>
    );
}
